export { default as EmptyStarIcon } from './EmptyStarIcon';
